import React, {Component} from 'react';

import formatters from "../../../../../utils/formatters";

export default class TripPlantEntry extends Component {

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;

        let pending =  <span className={"grey-text"}>-</span>;
        let entry_weight = trip.entry_weight ? trip.entry_weight : pending;
        let scale_in_datetime = pending;
        if(trip.scale_in_datetime){
            scale_in_datetime = formatters.datetimeFormat(trip.scale_in_datetime);
        }

        let scale = pending;
        if(trip.truck_scale && trip.truck_scale.code){scale = trip.truck_scale.code}

        let form = (
            <div>
                <div className={"discharge-title-section"}>Información de balanza</div>
                <div className={"row margin-top-20"}>
                    <div className={"col s3 offset-s1 input-field"}>
                        <label className="active">Fecha ingreso a la balanza</label>
                        <p className={"field-p"}>{scale_in_datetime}</p>
                    </div>
                    <div className={"col s3 input-field input-grey"}>
                        <label className="active">Pesaje inicial</label>
                        <p className={"field-p"}>{formatters.intFormat(entry_weight)}</p>
                    </div>
                    <div className={"col s3 input-field input-grey"}>
                        <label className="active">Balanza</label>
                        <p className={"field-p"}>{scale}</p>
                    </div>
                </div>
            </div>
        );

        if(this.props.boxed){
            return (
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>Ingreso a Terminal</div>
                    {form}
                </div>
            );
        }

        return form;
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Done/TripPlantEntry.js